export default "__VITE_ASSET__CanDSkT6__"